import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useInstituteService } from '../../../../apis/institute/useInstituteService';
import { IClassAndFeeStructureSchemaResponse } from '../../../../apis/institute/institute.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getGradeAndFeeStructureKey = 'get-grade-and-fee-structure';

export type TGradeAndFeeStructureQueryOptions = Omit<
  UseQueryOptions<IClassAndFeeStructureSchemaResponse, TQueryError>,
  'queryKey' | 'queryFn'
>;

export const useGradeAndFeeStructureHook = (
  options?: TGradeAndFeeStructureQueryOptions
): UseQueryResult<IClassAndFeeStructureSchemaResponse, TQueryError> => {
  const { getGradeAndFeeStructure } = useInstituteService();

  return useQuery<IClassAndFeeStructureSchemaResponse, TQueryError>({
    queryKey: [getGradeAndFeeStructureKey],
    queryFn: () => getGradeAndFeeStructure(),
    enabled: true,
    ...options,
  });
};
